<!-- TEMPLATE -->
<template>
  <li
    class="dropdown nav-item"
    v-bind:class="{ show: showNotifications }"
    v-on:click="showNotifications = !showNotifications"
  >
    <v-menu offset-y>
      <template v-slot:activator="{ on }">
        <a
          href="#"
          class="dropdown-toggle nav-link"
          data-toggle="dropdown"
          v-on="on"
        >
          <div id="new_notification_dot">
            <div
              v-bind:style="[ismobile ? { color: 'grey' } : { color: 'white' }]"
              v-bind:class="{ nonotification: newNotifications }"
              class="notification d-none d-lg-block d-xl-block d-md-block"
            >
              {{ notificationsCount }}
            </div>
          </div>
          <p v-if="!ismobile">
            <v-icon dark>mdi-bell-outline</v-icon>
          </p>
          <p v-if="ismobile">
            <v-icon light>mdi-bell-outline</v-icon>
            Notifications
          </p>
        </a>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, i) in notifications"
          :key="i"
          @click="markNotificationRead(item.id)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="" to="/notifications">
          <v-list-item-content>
            <v-list-item-title
              v-text="'Show all notifications'"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item @click="markAllRead()">
          <v-list-item-content>
            <v-list-item-title
              v-text="'Read all ' + notifications.length + ' notifications'"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </li>
</template>

<!-- SCRIPT -->
<script>
import PhishingApi from "../app/phishing-api";

export default {
  name: "Home",
  props: {
    ismobile: {
      default: true,
    },
  },
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfom,
      notificationsList: null,
      showNotifications: false,
    };
  },
  computed: {
    notifications: function () {
      return this.notificationsList;
    },
    notificationsCount: function () {
      return this.notifications ? this.notifications.length : 0;
    },
    newNotifications: function () {
      return this.notifications && this.notifications.length > 0 ? false : true;
    },
    isMobileWindow: function () {
      console.log(this.isMobile);
      return this.isMobile;
    },
  },
  mounted() {
    setInterval(
      () =>
        PhishingApi.getNotifications().then(
          (response) => (this.notificationsList = response)
        ),
      20000
    );
  },
  created() {
    PhishingApi.getNotifications().then(
      (response) => (this.notificationsList = response)
    );
  },
  methods: {
    markAllRead: function () {
      PhishingApi.markAllNotificationsRead()
        .then((response) => console.log("###" + response))
        .catch(function (error) {
          console.log("###" + error);
        });
      this.notificationsList = [];
    },
    markNotificationRead: function (id) {
      this.notificationsList.splice(
        this.notificationsList.findIndex((item) => item.id === id),
        1
      );
      PhishingApi.markNotificationRead(id)
        .then((response) => console.log("###" + response))
        .catch(function (error) {
          console.log("###" + error);
        });
    },
  },
};
</script>

<!-- Style -->
<style>
.nonotification {
  background: #cccccc !important;
  border: 1px solid #cccccc !important;
}
</style>